import { render, staticRenderFns } from "./EditAudition.vue?vue&type=template&id=51e6d452&"
import script from "./EditAudition.vue?vue&type=script&lang=js&"
export * from "./EditAudition.vue?vue&type=script&lang=js&"
import style0 from "./EditAudition.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports